export const FILED_MAP = {
    BONUSES: 20876981, // ID Поля в которое будет записано кол-во списываемых бонусов
    SAMPLI_SALE: 24463859, //
    SALE: 24463863, //
    CUPON: 81292033 //  ID Поля в которое будет записан промокод
};
export const FILED_HANDLE_MAP = {
    BONUSES: 'loyalty',
    SAMPLI_SALE: 'sample-sale',
    SALE: 'sale',
    CUPON: 'promocode'
};
export const CLIENT_GROUP_LIST = [
    {
        id: 24657,
        title: 'HOME31'
    },
    {
        id: 27303,
        title: 'Сотрудники'
    }
] as const;

// ID поля товара в котором записана информация об акциях
export const ACTION_PROP_ID = 37421688;

export const STATUS_DISCOUNT = {
    DISCOUNT_DELETED: 'DISCOUNT_DELETED'
};
export const TECHNICAL_STRING = 'LOYALTY_DISCOUNT';
export const TITLE_LIST = [
    {
        name: 'default',
        title: 'БОНУСЫ GATE31 MILES'
    },
    {
        name: 'Набор_футболок_BASE',
        title: 'Набор футболок'
    },
    {
        name: 'Скидка_партнерам:_30%',
        title: 'Программа лояльности'
    },
    {
        name: 'HOME31',
        title: 'СКИДКА HOME31'
    }
];

export const enum SpecialGroups {
    HOME31 = 'HOME31',
    PARTNER = 'Партнер',
}

export const SPECIAL_DISCOUNTS = {
    [SpecialGroups.HOME31]: 20,
    [SpecialGroups.PARTNER]: 31
} as const;
